export const getDropdownIsOpen = (state, props) =>
  state.dropdown[props.name] && state.dropdown[props.name].isOpen;

export const getDropdownIsHidden = (state, props) =>
  state.dropdown[props.name] && state.dropdown[props.name].isHidden;



// WEBPACK FOOTER //
// ./template/state/modules/dropdown/selectors.js